import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';

import { environment } from '@pp/environment';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  Sentry.init({
    dsn: 'https://d31d9ab7746761158177a94c69a8ecd5@o4507458923134976.ingest.de.sentry.io/4507528401649744',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    tracePropagationTargets: ['https://app.pay.partners'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });
}

bootstrapApplication(AppComponent, appConfig).catch(error => Sentry.captureException(error));
